import { render, staticRenderFns } from "./CountryDropdownField.vue?vue&type=template&id=33508b89"
import script from "./CountryDropdownField.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryDropdownField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33508b89')) {
      api.createRecord('33508b89', component.options)
    } else {
      api.reload('33508b89', component.options)
    }
    module.hot.accept("./CountryDropdownField.vue?vue&type=template&id=33508b89", function () {
      api.rerender('33508b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/CountryDropdownField.vue"
export default component.exports